import React, { createContext, useContext, useState, useCallback } from "react";

interface PageTitleContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
}

const PageTitleContext = createContext<PageTitleContextType | undefined>(
  undefined
);

export const PageTitleProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [pageTitle, setPageTitleState] = useState<string>("");
  const setPageTitle = useCallback((title: string) => {
    setPageTitleState(title);
  }, []);
  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitle = () => {
  const ctx = useContext(PageTitleContext);
  if (!ctx) {
    return { pageTitle: "", setPageTitle: () => {} };
  }
  return ctx;
};

export function useSetPageTitle(title: string) {
  const { setPageTitle } = usePageTitle();
  React.useEffect(() => {
    setPageTitle(title);
    return () => setPageTitle("");
  }, [title, setPageTitle]);
}
